import { render, staticRenderFns } from "./ListingSearchSummaryPage.vue?vue&type=template&id=2afab005&scoped=true&"
import script from "./ListingSearchSummaryPage.vue?vue&type=script&lang=ts&"
export * from "./ListingSearchSummaryPage.vue?vue&type=script&lang=ts&"
import style0 from "./ListingSearchSummaryPage.vue?vue&type=style&index=0&id=2afab005&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2afab005",
  null
  
)

export default component.exports